import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=f20d45a8&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=ts"
export * from "./Clients.vue?vue&type=script&lang=ts"
import style0 from "./Clients.vue?vue&type=style&index=0&id=f20d45a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20d45a8",
  null
  
)

export default component.exports